import { SizableText, SmartLink, XStack, XStackProps, YStack } from '@my/ui'
import { SolitoImage } from 'solito/image'

export interface AdBrandProps {
  brand: {
    id: string
    name: string
    logo: {
      url: string
      alt: string
    }
    href: string
  }
}

export const AdBrand = ({ brand, ...props }: AdBrandProps & XStackProps) => {
  return (
    <XStack p="$3.5" btlr="$3" btrr="$3" {...props}>
      <SmartLink
        Component={XStack}
        href={brand.href}
        gap="$2"
        flexShrink={1}
        $gtXs={{
          gap: '$3',
        }}
        hoverStyle={{
          opacity: 0.85,
        }}
        pressStyle={{
          opacity: 0.8,
        }}
        focusStyle={{
          opacity: 0.8,
        }}
      >
        <YStack flexShrink={0} w={44} h={44} bc="$white" br="$3" overflow="hidden">
          <SolitoImage
            fill
            src={brand.logo.url}
            alt={brand.logo.alt}
            contentFit="contain"
            sizes="(max-width: 567px) 36px, 44px"
          />
        </YStack>
        <YStack flexShrink={1}>
          <SizableText size="$4" numberOfLines={1} fow="600" $gtSm={{ size: '$5', fow: '600' }}>
            {brand.name}
          </SizableText>
          <SizableText size="$1" color="$overlay10">
            Sponsored
          </SizableText>
        </YStack>
      </SmartLink>
    </XStack>
  )
}
